import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmModel } from '../../model.module/modals.model';
import { ConfirmationObservable } from '../../services.module/message.observable';
import { Subscription } from 'rxjs';

@Component({
    selector: 'elem-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./modals.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmComponent implements OnDestroy {

    modalClass = 'modal hide';

    message: ConfirmModel = null;

    txtClose = 'Schließen';

    performAction = null;

    timeoutHandle = null;

    private confirmObsSub: Subscription;

    constructor(private readonly confirmObservable: ConfirmationObservable) {
        this.confirmObsSub = this.confirmObservable.subscribe((message: ConfirmModel) => {
            if (message === null) {
                return;
            }

            this.performAction = null;
            this.timeoutHandle = null;
            this.message = message;
            this.modalClass = 'modal dialog show';
        });
    }

    ngOnDestroy(): void {
        if (this.confirmObsSub) {
            this.confirmObsSub.unsubscribe();
        }
    }

    accept(): void {
        this.hideModal();
        this.message.confirmCallBackFunction();
        this.message = null;
    }

    hideModal(): void {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }

        if (this.performAction) {
            this.performAction();
        }

        this.modalClass = 'modal dialog hide';
    }

    close(): void {
        this.hideModal();
        this.message.cancelCallBackFunction();
        this.message = null;
    }

}
